module.exports = __webpack_public_path__ + "img/glider_blue.0181ed3e.png";